import React from "react";
import { Box, Typography } from "@mui/material";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { MyTimeDateHeaderTooltip } from "my-time/components";
import { useOcCalendar } from "oc/hooks";

interface MyTimeCalendarMonthlyDateHeaderProps {
  date: Date;
  label: string;
  isOffRange: boolean;
  countTimeData: (date: Date) => {
    workTime: number;
    overtime: number;
    voluntaryOvertime: number;
  };
}

export const MyTimeCalendarMonthlyDateHeader = (
  props: MyTimeCalendarMonthlyDateHeaderProps,
) => {
  const { date, label, isOffRange, countTimeData } = props;
  const { workTime, overtime, voluntaryOvertime } = countTimeData(date);

  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });
  let day = getDayOfYear(date);
  let dayState = Calendar?.charAt(day - 1);

  return (
    <MyTimeDateHeaderTooltip
      workTime={workTime}
      overtime={overtime}
      voluntaryOvertime={voluntaryOvertime}
      isOffRange={isOffRange}
      date={date}
    >
      <Box paddingRight="8px">
        <Typography
          variant="body1"
          style={{
            padding: 0,
            margin: 0,
            lineHeight: "16px",
            color: dayState === "F" ? "#cc0033" : "inherit",
          }}
        >
          {label}
        </Typography>
      </Box>
    </MyTimeDateHeaderTooltip>
  );
};

export default MyTimeCalendarMonthlyDateHeader;
